var FeatureExtractor = /** @class */ (function () {
    function FeatureExtractor() {
        this.extractors = [];
    }
    FeatureExtractor.prototype.register = function (extractors) {
        if (extractors === void 0) { extractors = []; }
        this.extractors = this.extractors.concat(extractors);
    };
    FeatureExtractor.prototype.extract = function (editorState, rawContentState) {
        var features = [];
        for (var _i = 0, _a = this.extractors; _i < _a.length; _i++) {
            var extractor = _a[_i];
            var feature = extractor(editorState, rawContentState);
            if (feature) {
                features.push(feature);
            }
        }
        return features;
    };
    return FeatureExtractor;
}());
export { FeatureExtractor };
//# sourceMappingURL=Extractor.js.map